var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative",class:_vm.$style.root},[_c('div',{staticClass:"absolute inset-0 w-full h-full border-2 border-current rounded-full",class:_vm.$style.top}),_c('div',{staticClass:"absolute inset-0 w-full h-full border-2 border-current rounded-full",class:_vm.$style.bottom})])
}
var staticRenderFns = []

export { render, staticRenderFns }